import React from 'react';

import s from './Stepper.module.scss';

type Props = {
  children: React.ReactNode;
};

const Stepper = ({ children }: Props) => {
  return <div className={s.stepper}>{children}</div>;
};

export default Stepper;
